import { DoctorDataModel } from '@models/ocs/doctor';
import { SearchDataModel } from '@models/ocs/search';

export enum DoctorListTypeEnum {
  OCS = 'OCS',
  NOBAT = 'NOBAT',
}

export type DiseaseDataModel = {
  doctorId: number;
  doctorName: string;
  specialityName: string;
  imageUrl: string;
  rate: number;
  carouselId: number;
  educationLevelId: number;
  medicalNumber: string;
};

type KeysOfUnion<T> = T extends T ? keyof T : never;

type MergeUnion<T> = {
  [K in KeysOfUnion<T>]?: T extends T
    ? K extends keyof T
      ? T[K]
      : never
    : never;
};

export type DoctorCardModel = MergeUnion<
  DoctorDataModel | SearchDataModel | DiseaseDataModel
>;
